<template>
  <div class="fz-sidebar__menu">
    <SfList>
      <SfListItem v-for="item in menu" :key="item.name">
        <router-link
          v-if="item.path"
          :to="item.path"
          v-slot="{ href, route, navigate, isActive }"
        >

          <SfMenuItem
            class="menu-item"
            @click="navigateWithClose(navigate, $event)"
            :label="$t(getRouteName(item))"
            :class="{ 'sf-menu-item--is-active': isActive }"
          />
        </router-link>
        <SfMenuItem
          class="menu-item"
          v-else
          @click="navigateWithClose(item.action, $event)"
        >
          {{ item.name }}
        </SfMenuItem>
      </SfListItem>
    </SfList>
    <div class="store-settings">
      <SfHeading class="sf-heading--left" :title="$t('Store settings:')" :level="4" />
      <LocaleChanger />
    </div>
  </div>
</template>
<script>
import {
  SfList,
  SfHeading,
  SfMenuItem,
} from '@storefront-ui/vue';
import { LocaleChanger, sidebar } from '@/modules/core';
import user from '../../mixins/user';
import myAccountLinks from '../../mixins/myAccountLinks';

export default {
  name: 'UserSidebarContent',
  mixins: [
    sidebar,
    user,
    myAccountLinks,
  ],
  components: {
    SfList,
    SfMenuItem,
    SfHeading,
    LocaleChanger,
  },
  data() {
    return {
      menuLoggdedOut: [
        {
          path: 'my-account',
          name: 'Log in',
        },
      ],
    };
  },
  computed: {
    menu() {
      return this.isAuthenticated
        ? this.myAccountLinks
        : this.menuLoggdedOut;
    },
  },
};
</script>
<style lang="scss" scoped>
.menu-item {
  padding: 5px 0;
}

.store-settings {
  padding: 30px 0;
}
</style>
